export =[
    {
        "star": {
            "fill": {
                "color": "rgba(182,74,9,0.2635968300410687)"
            },
            "opacity": 1,
            "stroke": {
                "color": "rgba(49,14,23,0.6699808995760113)",
                "width": 3.4639032010315107
            },
            "radius": 6.63376222856383,
            "radius2": 0,
            "points": 3
        },
        "text": {
            "fill": {
                "color": "rgba(207,45,78,0.44950090791791375)"
            },
            "stroke": {
                "color": "rgba(233,121,254,0.3105821877136521)",
                "width": 4.019676388210171
            },
            "text": "Test",
            "offset-x": 0,
            "offset-y": 14.239434215855646,
            "font": "18px fantasy"
        }
    }
];